<!--おしらせ-->
<template>
  <v-main>
    <section>
      <Title :title="title" :img="img"></Title>
    </section>
    <v-container class="mx-auto" style="max-width: 1100px;">
      <v-row no-gutters justify="center" align-content="center" class="mx-auto">
        <v-col>
          <v-data-table
              :headers="headers"
              hide-default-footer
              :items="notifications"
              group-by="category"
              :items-per-page="-1"
              disable-sort
          >
            <!-- アクション -->
            <template v-slot:item.actions="{item}">
              <router-link :to="{name: 'notification', params: { id: item.id }}">
                <v-btn
                    class="mr-4 font-weight-bold"
                    dark
                    small
                    color="primary"
                    min-width="120px"
                >
                  詳細を見る
                </v-btn>
              </router-link>
            </template>
            <template v-slot:group.header="{group, isOpen, toggle}">
              <td colspan="4" bgcolor="#E3F2FD">
                <v-btn @click="toggle" x-small icon :ref="group">
                  <v-icon v-if="isOpen">mdi-minus</v-icon>
                  <v-icon v-else>mdi-plus</v-icon>
                </v-btn>
                <span class="font-weight-bold">{{ group }}</span>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { Logger } from 'aws-amplify';
import { mapActions, mapGetters } from 'vuex';
import Title from '../components/Title';
import moment from 'moment/moment';

const logger = new Logger('notification');

export default {
  name: 'Notification',
  components: {
    Title,
  },
  props: {},

  async created() {
    logger.info('created');

    // TODO paginationの対応
    await this.getNotifications({
      count: 100,
      year: moment().format('YYYY'),
    });
  },

  data() {
    return {
      title: 'お知らせ一覧',
      img: 'title_notificationList.svg',
      headers: [
        {
          text: 'カテゴリ',
          align: 'center',
          value: 'category',
        },
        {
          text: 'タイトル',
          align: 'left',
          value: 'title',
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'actions',
        },
        {
          text: '投稿日時',
          align: 'center',
          value: 'contributedAt',
        },
        {
          text: '投稿者',
          align: 'center',
          value: 'contributor',
        },
      ],
    };
  },

  methods: {
    ...mapActions(['getNotifications']),
  },

  computed: {
    ...mapGetters(['notifications']),
  },
};
</script>

<style scoped lang="scss">

</style>